(function($, undefined) {
  'use strict';
  var win;
  var winWidth;
  var winHeight;
  var items;

  var autoScreenHeight = function() {
    items.each(function() {
      const t = $(this);

      const attr =
        t.data('autoScreenAttr') === undefined ? 'min-height' : t.attr('data-auto-screen-attr');
      const offset = () => {
        if (t.data('autoScreenOffset') !== undefined) {
          return t
            .data('autoScreenOffset')
            .replace(/\s+/g, '')
            .split(',');
        }
        return 0;
      };
      var factor = t.data('autoScreenFactor') !== undefined ? t.data('autoScreenFactor') : 1;
      var offsetHeight = 0;

      $.each(offset(), function(i) {
        var t = $(offset()[i]);
        offsetHeight += t.outerHeight();
      });

      var newHeight = winHeight * factor - offsetHeight;

      t.css(attr, newHeight);
    });
  };

  var init = function() {
    win = $(window);
    winWidth = win.width();
    winHeight = win.height();
    items = $('.js-auto-screen-height');

    autoScreenHeight();

    win.resize(function() {
      winWidth = win.width();
      winHeight = win.height();

      autoScreenHeight();
    });
  };

  $(window).ready(function() {
    init();
  });
})(jQuery);
